import ApiUrl from "../../configTools/apiUrl";

const Get = (body,setValues) => {
    //console.log(ApiUrl.API_URL_Filter+`/${body.category}/${body.subcategory}/${body.brand}/${body.condition}/${body.color}/${body.size}/${body.orderby}/${body.page}`);
    fetch(ApiUrl.API_URL_Filter+`/${body.category}/${body.subcategory}/${body.brand}/${body.condition}/${body.color}/${body.size}/${body.orderby}/${body.page}`)
    .then(res=>res.json())
    .then(data =>{
        setValues(data);
    });
}

const HashtagGet = (body,setValues) => {
    console.log(ApiUrl.API_URL_HashtagFilter+`/${body.value}/${body.category}/${body.subcategory}/${body.brand}/${body.condition}/${body.color}/${body.size}/${body.orderby}/${body.page}`)
    fetch(ApiUrl.API_URL_HashtagFilter+`/${body.value}/${body.category}/${body.subcategory}/${body.brand}/${body.condition}/${body.color}/${body.size}/${body.orderby}/${body.page}`)
    .then(res=>res.json())
    .then(data =>{
        setValues(data);
    });
}

const SearchProductGet = (body,setValues) => {
    console.log(ApiUrl.API_URL_SearchProduct+`/${body.value}/${body.category}/${body.subcategory}/${body.brand}/${body.condition}/${body.color}/${body.size}/${body.orderby}/${body.page}`);
    fetch(ApiUrl.API_URL_SearchProduct+`/${body.value}/${body.category}/${body.subcategory}/${body.brand}/${body.condition}/${body.color}/${body.size}/${body.orderby}/${body.page}`)
    .then(res=>res.json())
    .then(data =>{
        setValues(data);
    });
}

const Category = (setValues)=>{
    fetch(ApiUrl.API_URL_Collection)
    .then(res=>res.json())
    .then(data =>{
        setValues(data);
    });
}
const Brand = (setValues)=>{
    fetch(ApiUrl.API_URL_Brand)
    .then(res=>res.json())
    .then(data =>{
        setValues(data);
    });
}
const Condition = (setValues)=>{
    fetch(ApiUrl.API_URL_Condition)
    .then(res=>res.json())
    .then(data =>{
        setValues(data);
    });
}
const Color = (setValues)=>{
    fetch(ApiUrl.API_URL_Color)
    .then(res=>res.json())
    .then(data =>{
        setValues(data);
    });
}

export default {Get,HashtagGet,SearchProductGet,Category,Brand,Condition,Color}